import { render, staticRenderFns } from "./LoaCons5.vue?vue&type=template&id=1f7d22a6&"
import script from "./LoaCons5.vue?vue&type=script&lang=js&"
export * from "./LoaCons5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports